// extracted by mini-css-extract-plugin
module.exports = {"pinchZoomContainer":"az_B6c","pinchZoomWrapper":"az_C6c","pinchZoomContent":"az_D6c","overlayTextContainer":"az_E6c","overLayText":"az_F6c","carouselImage":"az_G6c"};